import i18n from "../../i18n/index";
import Kardex from "../../services/kardex/kardex-medicine.js";
import locationService from "../../services/location/LocationService.js";
import providerService from "../../services/provider/ProviderService.js";
import vademecum from "../../services/vademecum/Vademecum.js";
import kardexTransferList from "./list/Kardex-transfer-list.vue";

import dayjs from "dayjs";
import XLSX from "xlsx";
import kardexService from "../../services/kardex/kardex-medicine.js";

export default {
  components: {
    kardexTransferList,
  },
  data: () => ({
    headers: [
      { sortable: false, text: "PLU" },
      {
        sortable: false,
        text: "Nombre",
      },
      {
        sortable: false,
        text: "Lote",
      },
      { sortable: false, text: "Cantidad", value: "quantity" },
    ],
    fechaAllowed: "",
    branches: [],
    file: "",
    loaded: false,
    vademecumData: [],
    dataMedicines: [],
    hideList: false,
    loadingsave: false,
    editProccess: false,
    mun: {
      ActiveIngredient: "",
      descriptionActiveIngredient: "",
      nameTrade: "",
      pluCode: "",
      quantity: 0,
      isApplicable: false,
      isRegulated: false,
      active: true,
      provider: 0,
    },
    branch: {
      editFunction: false,
      id: "",
      name: "",
      branchId: "",
      providerId: "",
      type: "",
      branchCities: [],
      listCities: [],
      inactiveCities: [],
      newBranches: [],
    },
    loadinfarma: false,
    menuDelivery: false,
    menuDeliveryven: false,
    medicine: {
      date: new Date().toISOString().substr(0, 10),
      medicine: "",
      lote: "",
      dateVen: "",
      quantity: 0,
    },
    update: 0,
    rules: [
      (value) => !!value || i18n.t("field-required"),
      (v) => !v || v.length <= 200 || "Máximo 200 dígitos",
    ],

    numberRules: [
      (value) => !!value || i18n.t("field-required"),
      (v) => !v || v.length <= 10 || "Máximo 10 dígitos",
      (v) => !v || /^\d+$/.test(v) || "Solo números",
      // incluye aquí cualquier otra regla que necesites...
    ],
    validForm: true,
    loadingSaveButton: false,
    loadingDelete: false,
    showDelete: false,
    providers: [],
    file: "",
    loaded: false,
    errorMessage: "",
    loadingMasive: false,
    batches: [],
    availableQty: 0,
    targetBranch: {
      editFunction: false,
      id: "",
      name: "",
      branchId: "",
      providerId: "",
      type: "",
      branchCities: [],
      listCities: [],
      inactiveCities: [],
      newBranches: [],
    },
  }),
  created() {
    this.getProviders();
    this.getMedicines();
    // this.getBranches();
    this.gettoday();
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = item.description.toLowerCase();
      const textTwo = item.plu.toLowerCase();
      const textThree = String(item.id).toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.includes(searchText) ||
        textTwo.includes(searchText) ||
        textThree.includes(searchText)
      );
    },
    filterFunction(item, queryText) {
      return (
        item.plu.includes(queryText) ||
        item.description.toLowerCase().includes(queryText.toLowerCase()) ||
        item.id.includes(queryText)
      );
    },
    async readFile() {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function (e) {
          let data = e.target.result;
          data = new Uint8Array(data);
          let workbook = XLSX.read(data, { type: "array" });
          let result = {};
          let i = 0;
          workbook.SheetNames.forEach(function (sheetName) {
            let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            if (roa.length) {
              result[i] = roa;
              i++;
            }
          });
          resolve(result);
        };
        reader.onerror = function (event) {
          reader.abort();
          reject(reader.error);
        };
        reader.readAsArrayBuffer(this.file);
      });
    },
    async validateRowsAndGenerateMessage(dataFromExcel) {
      const requiredProps = [
        "provider",
        "branch",
        "dateAdd",
        "pluCode",
        "medicine",
        "dateDue",
        "lote",
        "quantity",
      ];
      let errorMessage = "";

      for (let i = 0; i < dataFromExcel[0].length; i++) {
        const row = dataFromExcel[0][i];
        const missingProps = [];

        requiredProps.forEach((prop) => {
          if (!row.hasOwnProperty(prop)) {
            missingProps.push(prop);
          }
        });

        if (missingProps.length > 0) {
          errorMessage += `<p> En la línea ${i + 1}: `;
          errorMessage += missingProps
            .map((prop) => `${prop} vacío`)
            .join(", ");
          errorMessage += "<p><br>";
        }
      }
      console.log(
        "🚀 ~ validateRowsAndGenerateMessage ~ this.errorMessage:",
        errorMessage
      );
      if (errorMessage !== "") {
        this.errorMessage = "<h3> Errores de vacios </h3>" + errorMessage;
      }
      // if (this.errorMessage !== '') {
      //     const errorDiv = document.createElement('div');
      //     errorDiv.textContent = this.errorMessage;
      //     return errorDiv;
      // } else {
      //     return null;
      // }
    },
    async validateDataTypesAndFormat(dataFromExcel) {
      //const dateRegex = /^\d{2}-\d{2}-\d{4}$/;}
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
      const alphanumericRegex = /^[a-zA-Z0-9]+$/;
      let errorMessage = "";

      for (let i = 0; i < dataFromExcel[0].length; i++) {
        const row = dataFromExcel[0][i];
        let lineError = "";

        if (
          row.provider != null &&
          row.provider !== "" &&
          isNaN(row.provider)
        ) {
          lineError += "provider no es un número. ";
        }

        if (row.branch != null && row.branch !== "" && isNaN(row.branch)) {
          lineError += ", branch no es un número. ";
        }

        if (
          row.dateAdd != null &&
          row.dateAdd !== "" &&
          !dateRegex.test(row.dateAdd)
        ) {
          lineError += ", dateAdd no tiene el formato dd-mm-yyyy. ";
        }

        if (
          row.pluCode != null &&
          row.pluCode !== "" &&
          !alphanumericRegex.test(row.pluCode)
        ) {
          lineError += ", pluCode no es texto alfanumérico. ";
        }

        if (
          row.medicine != null &&
          row.medicine !== "" &&
          isNaN(row.medicine)
        ) {
          lineError += ", medicine no es un número. ";
        }

        if (
          row.dateDue != null &&
          row.dateDue !== "" &&
          !dateRegex.test(row.dateDue)
        ) {
          lineError += ", dateDue no tiene el formato dd-mm-yyyy. ";
        }

        if (
          row.lote != null &&
          row.lote !== "" &&
          !alphanumericRegex.test(row.lote)
        ) {
          lineError += ", lote no es texto alfanumérico. ";
        }

        if (
          row.quantity != null &&
          row.quantity !== "" &&
          isNaN(row.quantity)
        ) {
          lineError += ", quantity no es un número. ";
        }

        if (lineError !== "") {
          errorMessage += `<p> En la línea ${i + 1}: ${lineError}<p><br>`;
        }
      }
      if (errorMessage !== "") {
        this.errorMessage +=
          "<h3> Errores de tipo de dato </h3>" + errorMessage;
      }
    },
    async submitForm() {
      try {
        this.loadingMasive = true;
        this.errorMessage = "";
        if (this.file !== undefined && this.file !== "") {
          this.loading = true;

          const dataFromExcel = await this.readFile();

          if (dataFromExcel[0].length === 0) {
            this.$notify({
              group: "app",
              type: "error",
              text: "El archivo no contiene información",
            });
            return;
          }

          await this.validateRowsAndGenerateMessage(dataFromExcel);
          await this.validateDataTypesAndFormat(dataFromExcel);

          if (this.errorMessage !== "") {
            this.$notify({
              group: "app",
              type: "error",
              text: "No ha cargado el archivo de ingreso masivo",
            });
            return;
          }

          const data = {
            data: dataFromExcel[0],
          };
          let response = await Kardex.bulkUpdate_kardex(data);

          if (response.data.code === 200) {
            this.loadingMasive = false;
            this.$notify({
              group: "app",
              type: "success",
              text: "ingreso masivo realizados con éxito",
            });
            this.loading = false;
          } else {
            this.loadingMasive = false;
            this.errorMessage +=
              "<h3> Errores en listados </h3>" + response.data.message;
            this.$notify({
              group: "app",
              type: "error",
              text: "No ha cargado el archivo de ingreso masivo",
            });
            this.loading = false;
          }
        } else {
          this.loadingMasive = false;
          this.$notify({
            group: "app",
            type: "error",
            text: "No ha cargado el archivo de ingreso masivo",
          });
        }
      } catch (error) {
        this.loadingMasive = false;
        this.$notify({
          group: "app",
          type: "error",
          text: error,
        });
      }
    },
    onChangeFileUpload() {
      if (this.$refs.file.files[0] !== undefined) {
        this.file = this.$refs.file.files[0];
        this.loaded = true;
      } else {
        this.loaded = false;
      }
    },
    downloadTemplate() {
      const columns = XLSX.utils.json_to_sheet([
        {
          provider: 7,
          branch: 172,
          dateAdd: "10-10-2024",
          pluCode: "01466546",
          medicine: 14302,
          dateDue: "10-12-2024",
          lote: "lote546",
          quantity: 500,
        },
        {
          provider: 7,
          branch: 172,
          dateAdd: "10-10-2024",
          pluCode: "5464645",
          medicine: 14402,
          dateDue: "10-12-2024",
          lote: "lote548",
          quantity: 500,
        },
      ]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, columns, "medicamentos");
      XLSX.writeFile(wb, "plantilla_ingreso_masivo_medicamentos.xlsx");
    },
    setAvailableQty(value) {
      this.availableQty = value.quantity;
    },
    addItem() {
      if (this.mun.provider === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-provider"),
        });
        return;
      }
      if (this.branch.branchId === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: "Debe seleccionar una farmacia de origen",
        });
        return;
      }

      if (this.targetBranch.branchId === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: "Debe seleccionar una farmacia destino",
        });
        return;
      }

      if (this.targetBranch.branchId === this.branch.branchId) {
        this.$notify({
          group: "app",
          type: "error",
          text: "La farmacia destino debe ser diferente a la farmacia de origen!",
        });
        return;
      }

      if (this.medicine.date === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-medicinedate"),
        });
        return;
      }
      if (this.medicine.medicine === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-medicine"),
        });
        return;
      }

      if (!this.medicine.lote) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Debe seleccionar un lote",
        });
        return;
      }

      if (this.mun.quantity === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-quantity"),
        });
        return;
      }

      if (this.mun.quantity == "0") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-quantity"),
        });
        return;
      }

      if (this.mun.quantity > this.availableQty) {
        this.$notify({
          group: "app",
          type: "error",
          text: "La cantidad a salir no puede ser superior a la cantidad disponible",
        });
        return;
      }

      if (
        this.dataMedicines.some(
          (med) =>
            med.pluCode === this.medicine.medicine.plu &&
            med.lote === this.medicine.lote.lote
        )
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-duplicate"),
        });
        return;
      }

      this.dataMedicines.push({
        medicinename: this.medicine.medicine.description,
        medicine: this.medicine.medicine.id,
        provider: this.providers.find((p) => p.id === this.mun.provider),
        branch: this.branches.find((b) => b.id === this.branch.branchId),
        targetBranch: this.branches.find(
          (b) => b.id === this.targetBranch.branchId
        ),
        pluCode: this.medicine.medicine.plu,
        lote: this.medicine.lote.lote,
        dateAdd: this.medicine.date,
        quantity: this.mun.quantity,
      });

      this.updateOrderType();
    },
    async updateOrderType() {
      let providersAux = [];
      this.dataMedicines.forEach((medicine) => {
        if (medicine.check === true) {
          if (!providersAux.includes(medicine.providerName)) {
            providersAux.push(medicine.providerName);
          }
        }
      });
      const moreThanOneProvider = providersAux.length > 1;
      this.itemTypeOrder = [
        { id: "EXCLUSIVE", name: "Póliza" },
        { id: "INTEGRATED", name: "Integrado" },
      ];
      // const oldOrderType = this.order.orderType;
      // this.order.orderType = !moreThanOneProvider ?
      // this.itemTypeOrder[0].id :
      // this.itemTypeOrder[1].id;

      // if (oldOrderType !== this.order.orderType) {
      //     await this.getStates();
      //     this.getCities();
      //     this.getBranches();
      // }

      // order.orderType.name = "PÓLIZA";
    },
    deleteTableRow(item) {
      const index = this.dataMedicines.indexOf(item);
      this.dataMedicines.splice(index, 1);
      const orderInarray = this.dataMedicines.find((medicine) => {
        return medicine.orderCode === item.orderCode;
      });
      if (orderInarray === undefined) {
        const index = this.scaleFee.findIndex(
          (element) => element.orderCode === item.orderCode
        );
        if (index >= 0) {
          this.scaleFee.splice(index, 1);
        }
        this.slidingScaleFeeTotal = 0;
        for (const fee of this.scaleFee) {
          this.slidingScaleFeeTotal += parseInt(fee.scaleFee);
        }
      }

      const patientInarray = this.dataMedicines.find((medicine) => {
        return medicine.document === item.document;
      });
      if (patientInarray === undefined) {
        const index = this.patientListData.findIndex(
          (patient) => patient.document === item.document
        );
        if (index >= 0) {
          this.patientListData.splice(index, 1);
        }
      }
      this.updateOrderType();
    },
    async Provider(providerId) {
      this.loadinfarma = true;
      this.branches = [];
      this.batches = [];
      return await locationService
        .getBranchesByProvider(providerId)
        .then((response) => {
          this.loadinfarma = false;
          this.branches = response.data;
          if (this.branches && this.branches.code) {
            this.branches = [];
          }
        });
    },
    gettoday() {
      // Obtener la fecha actual
      const today = new Date();
      this.fechaAllowed = dayjs(today).format("YYYY-MM-DD");
      // console.log("🚀 ~ gettoday ~ fechaAllowed:", fechaAllowed)
      this.medicine.date = this.fechaAllowed;
    },
    getMedicines() {
      this.batches = [];

      vademecum.getVademecumOrder().then((response) => {
        this.vademecumData = response.data;

        for (let index = 0; index < this.vademecumData.length; index++) {
          const medicinee = this.vademecumData[index];
          // if (medicinee.isApplicable || medicinee.isWatched) {
          //     this.vademecumData[index].disabled = true;
          // }
        }
        return this.vademecumData;
      });
    },
    getBatchsWithAmount() {
      this.batches = [];
      this.availableQty = 0;
      this.mun.quantity = 0;

      kardexService
        .getKardexBatchWithAmounts(
          this.mun.provider,
          this.branch.branchId,
          this.medicine.medicine.id
        )
        .then((response) => {
          this.batches = response.data[0];
          if(response.data[1]=== 0){
            this.$notify({
              group: "app",
              type: "error",
              text: "No se encontró inventario para el medicamento seleccionado.",
            });
          }
        });
    },
    // async getBranches() {
    //     let response = await branchService.allBranchesPolicy();
    //     this.branches = response.data[0];
    // },
    closeCreate() {
      this.hideList = false;
      this.branch.editFunction = false;
      this.branch.branchId = null;
      this.branch.branchCities = [];
      this.branch.listCities = [];
      this.branch.inactiveCities = [];
      this.showFunction();
    },
    save() {
      if (this.dataMedicines.length == 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.error-required-fields"),
        });
        return;
      }
      // this.mun.id = this.mun.id == '' ? this.$refs.munipicioList.getLenght() + 1 : this.mun.id;
      this.editProccess = false;

      const medicines = this.dataMedicines.map((d) => ({
        medicine: d.medicine,
        pluCode: d.pluCode,
        lote: d.lote,
        quantity: d.quantity,
      }));

      const data = {
        sourceProvider: this.dataMedicines[0].provider.id,
        sourceBranch: this.dataMedicines[0].branch.id,
        targetProvider: this.dataMedicines[0].provider.id,
        targetBranch: this.dataMedicines[0].targetBranch.id,
        movementType: "TF",
        medicines,
      };

      kardexService
        .createTransferKardex(data)
        .then((result) => {
          if (result.status == 200) {
            this.$notify({
              group: "app",
              type: "success",
              text: i18n.t("record-successfully-created"),
            });
          }
          this.$refs.municipioList.searchCity();
          this.dataMedicines = [];
          this.closeUser();
          this.loadingsave = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    closeUser() {
      this.hideList = false;
      this.dialog = false;
      this.mun = {
        ActiveIngredient: "",
        descriptionActiveIngredient: "",
        nameTrade: "",
        pluCode: "",
        quantity: 0,
        isApplicable: false,
        isRegulated: true,
        active: true,
      };
      this.showIcon = false;
      this.$refs.municipioform.reset();
      this.editProccess = false;
      this.update = 0;
      this.showDelete = false;
    },
    async getProviders() {
      return await providerService.getProviders().then((response) => {
        this.providers = response.data;
      });
    },
  },
};
